import * as React from 'react';

const Empty = () => {
    return <React.Fragment />;
};
export default Empty;
